(function () {
  'use strict';

  const CONFIG = {
    threshold     : 11000,        // 送料無料の閾値（円）
    headerSelector: '.header-wrapper',
    barId         : 'free-shipping-bar',
  };

  // --- カート情報を取得 ---
  async function getCart() {
    try {
      const res  = await fetch('/cart.js');
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  // --- 金額を整形 ---
  function formatYen(num) {
    return '¥' + num.toLocaleString('ja-JP');
  }

  // --- ヘッダー上部のバーを作成 ---
  function createHeaderBar() {
    if (document.getElementById(CONFIG.barId)) return;

    const bar = document.createElement('div');
    bar.id = CONFIG.barId;
    bar.className = 'free-shipping-bar';
    bar.innerHTML = `
      <div class="free-shipping-bar__inner">
        <span class="free-shipping-bar__text"></span>
        <div class="free-shipping-bar__progress">
          <div class="free-shipping-bar__progress-fill"></div>
        </div>
      </div>
    `;

    const header = document.querySelector(CONFIG.headerSelector);
    if (header) {
      header.parentNode.insertBefore(bar, header);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }

  // --- カートドロワー内のバーを作成 ---
  function createCartBar() {
    const cartDrawer = document.querySelector('.cart-drawer, #CartDrawer, [data-cart-drawer]');
    if (!cartDrawer) return;
    if (cartDrawer.querySelector('.cart-shipping-bar')) return;

    const bar = document.createElement('div');
    bar.className = 'cart-shipping-bar';
    bar.innerHTML = `
      <div class="cart-shipping-bar__text"></div>
      <div class="cart-shipping-bar__progress">
        <div class="cart-shipping-bar__progress-fill"></div>
      </div>
    `;

    const target = cartDrawer.querySelector('.drawer__inner, .cart__items, form[action*="cart"]') || cartDrawer;
    target.insertBefore(bar, target.firstChild);
  }

  // --- バーを更新 ---
  function updateBars(cart) {
    if (!cart) return;

    const total      = cart.total_price / 100;
    const remaining  = Math.max(0, CONFIG.threshold - total);
    const percentage = Math.min(100, (total / CONFIG.threshold) * 100);
    const isFree     = remaining === 0;

    const message = isFree
      ? '🎉 送料無料です！'
      : `あと <strong>${formatYen(remaining)}</strong> で送料無料！`;

    // ヘッダー上部
    const headerBar = document.getElementById(CONFIG.barId);
    if (headerBar) {
      const text = headerBar.querySelector('.free-shipping-bar__text');
      const fill = headerBar.querySelector('.free-shipping-bar__progress-fill');
      if (text) text.innerHTML = message;
      if (fill) fill.style.width = percentage + '%';
      headerBar.classList.toggle('is-free', isFree);
    }

    // カートドロワー
    const cartBar = document.querySelector('.cart-shipping-bar');
    if (cartBar) {
      const text = cartBar.querySelector('.cart-shipping-bar__text');
      const fill = cartBar.querySelector('.cart-shipping-bar__progress-fill');
      if (text) text.innerHTML = message;
      if (fill) fill.style.width = percentage + '%';
      cartBar.classList.toggle('is-free', isFree);
    }
  }

  // --- 初期化 ---
  async function init() {
    createHeaderBar();
    createCartBar();
    const cart = await getCart();
    updateBars(cart);
  }

  // --- カート更新時に再取得 ---
  async function refresh() {
    createCartBar();
    const cart = await getCart();
    updateBars(cart);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('page:load', init);

  // カート更新を監視（Streamlineのカスタムイベント）
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:open', refresh);

  // fetch APIをフックしてカート操作を検知
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    return originalFetch.apply(this, args).then(response => {
      const url = args[0];
      if (typeof url === 'string' && url.includes('/cart')) {
        setTimeout(refresh, 300);
      }
      return response;
    });
  };

  // カートドロワーが後から生成される場合に備えて監視
  const mo = new MutationObserver(() => {
    if (!document.querySelector('.cart-shipping-bar')) {
      createCartBar();
      refresh();
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

})();